import { Link } from 'react-router-dom';
import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/feature/ArticleCard';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function Home() {
  const [faqOpen, setFaqOpen] = useState<number | null>(null);

  const faqs = [
    { q: '美女视频App需要付费吗？', a: '大部分美女视频App都提供免费下载和基础功能体验，用户可以免费观看海量短视频内容。部分平台提供VIP会员服务，解锁高清画质、去广告、专属内容等高级功能。建议先从免费版开始体验，根据需求决定是否升级。' },
    { q: '美女视频App安全吗？', a: '我们推荐的所有美女视频App均已通过主流应用商店的安全审核，不含恶意代码和病毒。建议用户通过官方应用商店下载，避免使用来路不明的第三方安装包。同时请注意保护个人隐私，合理使用平台功能。' },
    { q: '如何选择适合自己的美女视频App？', a: '选择美女视频App时，建议从以下几个方面考虑：1）内容丰富度——是否包含你感兴趣的内容类型；2）画质清晰度——是否支持高清播放；3）用户体验——界面是否流畅、操作是否便捷；4）更新频率——内容是否每日更新。可以参考我们网站的详细评测文章做出选择。' },
    { q: '可以用美女视频App做直播吗？', a: '当然可以！大部分美女视频App都支持直播功能。注册账号并通过实名认证后，即可开启直播。新手主播建议先观看平台的新手教程，了解直播规范和注意事项，选择适合自己的直播内容和风格。' },
    { q: '美女视频App的画质怎么样？', a: '主流美女视频App普遍支持1080P高清播放，部分旗舰级App更是支持4K超清画质。画质效果还取决于你的网络环境和设备性能。建议在WiFi环境下观看高清视频，以获得最佳观看体验。' },
  ];

  const featuredArticles = articles.slice(0, 6);
  const latestArticles = articles.slice(6);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '美女视频推荐',
    url: 'https://beautyvideo.app',
    description: '精选美女视频app推荐，海量高清美女短视频资源，颜值博主直播互动，每日更新不间断。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://beautyvideo.app/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '美女视频推荐',
    url: 'https://beautyvideo.app',
    description: '专注于美女视频App推荐与评测的内容平台',
    email: 'contact@beautyvideo.app',
    telephone: '400-888-8888',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '建国路88号',
      addressLocality: '北京',
      addressRegion: '朝阳区',
      addressCountry: 'CN',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        {/* Hero Section */}
        <header className="relative w-full h-[550px] md:h-[650px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20young%20Asian%20woman%20portrait%20with%20warm%20golden%20sunset%20backlight%2C%20soft%20dreamy%20atmosphere%2C%20cream%20and%20warm%20beige%20background%2C%20editorial%20beauty%20photography%2C%20minimalist%20aesthetic%2C%20luxurious%20feeling&width=1920&height=900&seq=hero-beauty-2024&orientation=landscape"
            alt="美女视频App推荐"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/50"></div>
          <div className="relative z-10 w-full px-4 md:px-6 text-center">
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight">
              美女视频App推荐2024
            </h1>
            <p className="text-base md:text-xl text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed">
              精选美女视频App推荐，海量高清美女短视频资源，颜值博主直播互动，每日更新不间断
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="#featured"
                className="px-8 py-3.5 bg-primary-500 text-background-50 font-medium rounded-full whitespace-nowrap transition-all hover:bg-primary-600 cursor-pointer text-sm md:text-base"
              >
                立即探索
              </a>
              <Link
                to="/about"
                className="px-8 py-3.5 bg-background-50/15 text-background-50 font-medium rounded-full whitespace-nowrap border border-background-50/30 transition-all hover:bg-background-50/25 cursor-pointer text-sm md:text-base"
              >
                了解更多
              </Link>
            </div>
          </div>
        </header>

        <main>
          {/* Category Navigation */}
          <section className="w-full px-4 md:px-6 py-12 md:py-16">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                  探索精彩内容
                </h2>
                <p className="text-foreground-500 text-sm md:text-base">
                  六大分类，满足你对美女短视频的所有期待
                </p>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
                {categories.map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className="group flex flex-col items-center gap-3 p-5 md:p-6 bg-background-50 rounded-xl border border-background-200/70 transition-all duration-300 hover:border-primary-300 hover:bg-primary-50/50 cursor-pointer"
                  >
                    <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                      <i className={`${cat.icon} text-xl md:text-2xl`}></i>
                    </div>
                    <span className="font-heading font-semibold text-foreground-800 text-sm md:text-base whitespace-nowrap">
                      {cat.name}
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          {/* Featured Articles */}
          <section id="featured" className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-10">
                <div>
                  <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
                    精选推荐
                  </h2>
                  <p className="text-foreground-500 text-sm">编辑团队精心挑选的优质内容</p>
                </div>
                <Link
                  to="/category/re-men-tui-jian"
                  className="hidden sm:flex items-center gap-1 text-primary-600 hover:text-primary-700 font-medium text-sm cursor-pointer whitespace-nowrap"
                >
                  查看全部 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {featuredArticles.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
              <div className="mt-8 text-center sm:hidden">
                <Link
                  to="/category/re-men-tui-jian"
                  className="inline-flex items-center gap-1 text-primary-600 font-medium text-sm cursor-pointer"
                >
                  查看全部 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </section>

          {/* App Download CTA */}
          <section className="w-full px-4 md:px-6 py-14 md:py-20 relative overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20beautiful%20video%20content%20on%20screen%2C%20clean%20minimalist%20desk%20setup%20with%20warm%20lighting%2C%20cream%20and%20beige%20aesthetic%2C%20lifestyle%20tech%20photography&width=1920&height=600&seq=cta-download-app&orientation=landscape"
              alt="下载美女视频App"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-black/30 to-black/40"></div>
            <div className="relative z-10 max-w-4xl mx-auto text-center">
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
                随时随地，高清美女短视频一键畅享
              </h2>
              <p className="text-background-200 text-sm md:text-lg mb-8 max-w-xl mx-auto">
                下载美女视频App，海量高清内容每日更新，操作简单流畅，新用户专属福利等你领取
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <a href="#" className="px-10 py-4 bg-background-50 text-foreground-900 font-semibold rounded-full whitespace-nowrap transition-all hover:bg-background-100 cursor-pointer text-sm md:text-base flex items-center gap-2">
                  <i className="ri-android-line text-lg"></i> Android下载
                </a>
                <a href="#" className="px-10 py-4 bg-background-50/15 text-background-50 font-semibold rounded-full whitespace-nowrap border border-background-50/40 transition-all hover:bg-background-50/25 cursor-pointer text-sm md:text-base flex items-center gap-2">
                  <i className="ri-apple-line text-lg"></i> iOS下载
                </a>
              </div>
            </div>
          </section>

          {/* Latest Articles */}
          <section className="w-full px-4 md:px-6 py-12 md:py-16">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                  最新内容
                </h2>
                <p className="text-foreground-500 text-sm">持续更新，发现更多精彩</p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {latestArticles.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            </div>
          </section>

          {/* FAQ Section */}
          <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
            <div className="max-w-3xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                  常见问题
                </h2>
                <p className="text-foreground-500 text-sm">关于美女视频App的常见问题解答</p>
              </div>
              <div className="flex flex-col gap-3">
                {faqs.map((faq, index) => (
                  <div
                    key={index}
                    className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
                  >
                    <button
                      className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
                      onClick={() => setFaqOpen(faqOpen === index ? null : index)}
                    >
                      <span className="font-heading font-semibold text-foreground-800 text-sm md:text-base pr-4">
                        {faq.q}
                      </span>
                      <i className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-300 text-lg ${faqOpen === index ? 'rotate-180' : ''}`}></i>
                    </button>
                    {faqOpen === index && (
                      <div className="px-5 pb-5">
                        <p className="text-foreground-600 text-sm leading-relaxed">{faq.a}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}